import { uid } from '../../../../lib/uid';

/**
 * Sample values for a PPA and its budgeted lines.
 *
 * **The FIELD VALUES live here; the CATALOG PICKS stay at the call site.** A generator
 * cannot resolve a goal, a fund source or an account code honestly — it has to choose from
 * the options the form already loaded, or it invents an id the server refuses and the form
 * reads as broken. So the modal picks from its own loaded lists and this module answers the
 * rest, which is the split every other generator in this feature takes.
 */

const ACTIVITIES = [
  'Barangay health station upgrade',
  'Farm-to-market road rehabilitation',
  'Solid waste segregation programme',
  'Senior citizens welfare assistance',
  'Flood control desilting works',
  'Scholarship grants programme',
  'Public market roofing repair',
];

const OUTCOMES = [
  'A measurable improvement recorded against this activity.',
  'Service coverage widened within the fiscal year.',
  'Backlog cleared and the turnaround time reduced.',
  'Facilities returned to serviceable condition.',
];

const LINES = [
  'Medical supplies',
  'Fuel, oil and lubricants',
  'Travelling expenses',
  'Repairs and maintenance',
  'Training expenses',
  'Office supplies',
  'Electricity',
];

function pick<T>(values: readonly T[]): T {
  return values[Math.floor(Math.random() * values.length)];
}

/** Six characters is enough to make a repeated click produce a name the server accepts. */
function suffix(): string {
  return uid().slice(0, 6).toLowerCase();
}

/**
 * One PPA's own facts.
 *
 * The name carries a suffix for the reason every other name here does — Autogenerate is most
 * useful clicked repeatedly, and two PPAs under one plan and department may not share a name.
 */
export function samplePpa(): { name: string; expectedOutcome: string } {
  return {
    name: `${pick(ACTIVITIES)} ${suffix()}`,
    expectedOutcome: pick(OUTCOMES),
  };
}

/**
 * One budgeted line — the description and the amount, and NEITHER date.
 *
 * A budget is written for a fiscal year this generator does not know, so any window it
 * produced would be a guess presented as a fact. That is the "a field it cannot write
 * honestly" case, and both dates are optional, so the absence blocks nothing.
 */
export function samplePpaLine(index: number): { item: string; amount: number } {
  return {
    item: `${pick(LINES)} ${index + 1}`,
    amount: Math.round((Math.random() * 400_000 + 10_000) / 100) * 100,
  };
}
